import React from "react";

export default ({ mandatory }) => {
  if (!mandatory) {
    return null;
  }
  return <div style={{ color: "red", fontSize: 20 }}>*</div>;
};
